import { AVATARS } from '@retro/shared';
import clsx from 'clsx';

export function AvatarPicker({
  value,
  onChange,
  name,
  error,
}: {
  value: string;
  onChange: (avatar: string) => void;
  name: string;
  error?: string;
}) {
  return (
    <div className="space-y-2">
      <fieldset className="space-y-3">
        <legend className="text-sm font-medium">Choose an avatar</legend>
        <div role="radiogroup" aria-label={name} className="grid grid-cols-6 gap-2 sm:grid-cols-8">
          {AVATARS.map((avatar) => (
            <button
              key={avatar}
              type="button"
              role="radio"
              aria-checked={value === avatar}
              aria-label={`Avatar ${avatar}`}
              onClick={() => onChange(avatar)}
              className={clsx(
                'flex h-12 w-12 items-center justify-center rounded-xl border transition hover:border-brand-500',
                value === avatar ? 'border-brand-500 bg-brand-50' : 'border-black/10',
              )}
            >
              <span className="text-2xl">{avatar}</span>
            </button>
          ))}
        </div>
      </fieldset>
      {error ? <p role="alert" className="text-sm text-rose-600">{error}</p> : null}
    </div>
  );
}
